'use strict';

const jQuery = require('jquery');

const RequestHandler = require('./../../../core/requestHandler');

const baseType = 'tags';

module.exports.delete = function(uid) {
  let result;

  RequestHandler.setBaseUrl('/api');

  result = RequestHandler.del(baseType + '/' + uid);

  RequestHandler.setBaseUrl('/rest/2');

  return result;
};

module.exports.find = function(uid) {
  let result;

  RequestHandler.setBaseUrl('/api');

  result = RequestHandler.read(baseType + '/' + uid);

  RequestHandler.setBaseUrl('/rest/2');

  return result;
};

module.exports.findBy = function(criterias, context = 'search') {
  let result;

  RequestHandler.setBaseUrl('/api');

  result = RequestHandler.read(baseType + '?context=' + context, criterias);

  RequestHandler.setBaseUrl('/rest/2');

  return result;
};

module.exports.findByParent = function(parentUid) {
  let result;

  RequestHandler.setBaseUrl('/api');

  result = RequestHandler.read(`${baseType}/${parentUid}/children`);

  RequestHandler.setBaseUrl('/rest/2');

  return result;
};

module.exports.findFirstLevel = () => {
  let result;

  RequestHandler.setBaseUrl('/api');

  result = RequestHandler.read(baseType + '/tree-first-level');

  RequestHandler.setBaseUrl('/rest/2');

  return result;
};

module.exports.findFirstList = function() {
  let dfd = jQuery.Deferred();
  let func = () => {
    let promises = [];

    promises.push(module.exports.findBy({'range': '0-49'}));
    promises.push(module.exports.findBy({'range': '50-99'}));
    promises.push(module.exports.findBy({'range': '100-149'}));

    return jQuery.when.apply(undefined, promises).promise();
  };

  func().done((first, second, third) => {
    dfd.resolve([].concat(first[0], second[0], third[0]), third[1]);
  });

  return dfd.promise();
};

window.yaqian = module.exports.findFirstList;

module.exports.findLinkedPages = function(uid) {
  let result;

  RequestHandler.setBaseUrl('/api');

  result = RequestHandler.read(baseType + '/' + uid + '/linked-pages');

  RequestHandler.setBaseUrl('/rest/2');

  return result;
};

module.exports.create = function(data) {
  let result;

  RequestHandler.setBaseUrl('/api');

  result = RequestHandler.create(baseType, data);

  RequestHandler.setBaseUrl('/rest/2');

  return result;
};

module.exports.update = function(data) {
  let result;

  RequestHandler.setBaseUrl('/api');

  result = RequestHandler.update(baseType, data, {'uid': data.uid});

  RequestHandler.setBaseUrl('/rest/2');

  return result;
};
